import type { AspectRatioVariant } from "./types";

/**
 * Aspect ratio values for each variant
 * Format: width / height
 */
export const ASPECT_RATIOS: Record<Exclude<AspectRatioVariant, "auto">, number> = {
  hero: 21 / 9, // Ultra-wide hero images (2.33:1)
  wide: 16 / 9, // Standard wide format (1.78:1)
  video: 16 / 9, // Video format (1.78:1)
  landscape: 4 / 3, // Landscape images (1.33:1)
  square: 1 / 1, // Square images (1:1)
  portrait: 3 / 4, // Portrait images (0.75:1)
  card: 3 / 2 // Card format (1.5:1)
};

/**
 * Get aspect ratio percentage for CSS padding-bottom trick
 * @param variant - Aspect ratio variant
 * @returns Percentage string for padding-bottom
 */
export function getAspectRatioPadding(variant: AspectRatioVariant): string | undefined {
  if (variant === "auto") return undefined;

  const ratio = ASPECT_RATIOS[variant];
  // Calculate percentage: (height / width) * 100
  return `${(1 / ratio) * 100}%`;
}

/**
 * Get CSS class name for aspect ratio variant
 * @param variant - Aspect ratio variant
 * @returns CSS class name
 */
export function getAspectRatioClassName(variant?: AspectRatioVariant): string {
  if (!variant || variant === "auto") return "";
  return `aspect-${variant}`;
}
